
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/upload-bank-statements",
      function () {
        return require("private-next-pages/apply/upload-bank-statements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/upload-bank-statements"])
      });
    }
  